import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Whether the Refinery page is following a run in progress (Run Refinery / Run Node).
 * The run itself is a server-side job (docs/Run_Job_Architecture.md); this only lets the
 * app shell disable navigation that would leave the page while it shows that run,
 * keeping Sign Out available. */
@Injectable({ providedIn: 'root' })
export class RunStatusService {
  private readonly runningSubject = new BehaviorSubject<boolean>(false);
  readonly running$ = this.runningSubject.asObservable();

  setRunning(running: boolean): void {
    if (this.runningSubject.value !== running) {
      this.runningSubject.next(running);
    }
  }
}
